module.exports = "../static/media/banner_short.7efb98a6.png";